import { render } from "./App.vue?vue&type=template&id=66229752"
const script = {}

import "./App.vue?vue&type=style&index=0&id=66229752&lang=scss"
script.render = render

export default script